import React, { createContext, useContext, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import './page-transition.css'

const PageTransitionContext = createContext(null)

const COVER_MS = 500
const REVEAL_MS = 500

export function PageTransitionProvider({ children }) {
  const overlayRef = useRef(null)
  const navigate = useNavigate()
  const isAnimating = useRef(false)

  const navigateWithTransition = useCallback((to) => {
    if (isAnimating.current) return
    isAnimating.current = true
    const overlay = overlayRef.current

    overlay.classList.add('is-covering')

    setTimeout(() => {
      navigate(to)
      window.scrollTo(0, 0)

      overlay.classList.remove('is-covering')
      overlay.classList.add('is-revealing')

      setTimeout(() => {
        overlay.classList.add('no-transition')
        overlay.classList.remove('is-revealing')
        // Force reflow so the instant reset above is applied before transitions are re-enabled.
        void overlay.offsetHeight
        overlay.classList.remove('no-transition')
        isAnimating.current = false
      }, REVEAL_MS)
    }, COVER_MS)
  }, [navigate])

  return (
    <PageTransitionContext.Provider value={{ navigateWithTransition }}>
      {children}
      <div ref={overlayRef} className="page-transition-overlay" aria-hidden="true">
        <span className="page-transition-mark">RD</span>
      </div>
    </PageTransitionContext.Provider>
  )
}

export function usePageTransition() {
  return useContext(PageTransitionContext)
}
